import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FiPhone, FiYoutube } from "react-icons/fi";
import media from "../../styles/media";
import Container from "../ui/Container";
import { CONTACTS } from "../../config/navigation";
import { ROUTES } from "../../config/routes";
import LanguageSwitcher from "./LanguageSwitcher";
import emblem from "../../assets/img/emblem.png";

const Wrapper = styled.div`
  padding: 20px 0;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  ${media.lg} {
    flex-wrap: wrap;
  }
`;

const Brand = styled(Link)`
  display: flex;
  align-items: center;
  gap: 16px;
  color: inherit;

  &:hover {
    text-decoration: none;
  }
`;

const Logo = styled.img`
  width: 64px;
  height: auto;
  flex-shrink: 0;
`;

const BrandText = styled.span`
  max-width: 330px;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.primary};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.xs};
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  ${media.sm} {
    width: 100%;
    justify-content: space-between;
    gap: 10px;
  }
`;

const YoutubeLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 600;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDark};
    text-decoration: none;
  }
`;

const Phone = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  white-space: nowrap;

  ${media.sm} {
    display: none;
  }
`;

export function TopBar() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Inner>
          <Brand to={ROUTES.home}>
            <Logo src={emblem} alt="" />
            <BrandText>{t("text1")}</BrandText>
          </Brand>

          <Actions>
            <YoutubeLink
              href={CONTACTS.youtube}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FiYoutube aria-hidden="true" />
              YouTube
            </YoutubeLink>

            <Phone href={CONTACTS.phoneHref}>
              <FiPhone aria-hidden="true" />
              {CONTACTS.phone}
            </Phone>

            <LanguageSwitcher />
          </Actions>
        </Inner>
      </Container>
    </Wrapper>
  );
}

export default TopBar;
